export default __webpack_public_path__ + "incidentManagementIcon.png";